<template>
    <div class="checkbox-form" @click.stop>
        <label class="item">
            <input
                class="new-checkbox"
                type="checkbox"
                v-model="newValue"
                @change.stop="onChange"
            />
            <span class="checkmark"></span>
            <span class="label" v-if="!noLabel"><slot></slot></span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [Boolean]
        },
        noLabel: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            newValue: this.value,
            focused: false
        };
    },
    watch: {
        value() {
            this.newValue = this.value;
        }
    },
    methods: {
        onChange() {
            this.$emit("change", this.newValue);
            this.$emit("input", this.newValue);
        }
    }
};
</script>

<style lang="scss" scoped>
.checkbox-form {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.checkbox-form .item {
    position: relative;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 1em;
    height: 25px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: flex;
    align-items: center;

    .label {
        padding-right: 10px;
    }
}

.checkbox-form input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkbox-form .checkmark {
    position: relative;
    top: 0;
    right: 0;
    height: 25px;
    width: 25px;
    background-color: #fbfbfb;
    border-radius: 4px;
    border: 1px solid #cfd6e6;
}

.checkbox-form .item input:checked ~ .checkmark {
    background-color: #cfd6e6;
}

.checkbox-form .checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.checkbox-form .item input:checked ~ .checkmark:after {
    display: block;
}

.checkbox-form .item .checkmark:after {
    left: 9px;
    top: 5px;
    width: 6px;
    height: 10px;
    border: solid #000;
    border-width: 0 1px 1px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
</style>
